/* global document */
import Player from './Player';

/**
 * Injects the player elements into the DOM
 *
 * @param {Object} settings base settings to pass to each player
 */
export default class PlayerInjector {
  constructor(settings) {
    this.instances = [];
    this.settings = settings;
  }

  /**
   * Initialize players on the given window.
   *
   * @param {*} window - A Navigator Window object.
   * @param {*} elements - The elements to which to attach players.
   */
  initialize(window, elements) {
    if (typeof window.hearstPlayerCallback === 'function') {
      window.hearstPlayerCallback.apply(this);
    } else {
      this.initPlayerElements(elements);
    }
  }

  /**
   * Start attaching all the players on the page based on the
   * settings.playerClass.
   *
   * @param elements Array of DOM Elements to be used for player injection
   */
  initPlayerElements(elements) {
    const playerElements = elements || [
      ...document.querySelectorAll(`.${this.settings.playerClass}`),
    ];

    playerElements
      .filter(e => !e.classList.contains(this.settings.loadedClass))
      .forEach(el => this.initPlayerElement(el));
  }

  /**
   * Attach a single player object to the specified DOM element.
   *
   * @param el {HTMLElement} The element to which to attach the player.
   */
  initPlayerElement(el) {
    const player = this.loadPlayer(el, this.settings);

    // Only doing these post-init because we don't want to fiddle
    // with busted player instances.
    if (player) {
      this.instances.push(player);
      el.classList.add(this.settings.loadedClass);
    }
  }

  /**
   * This method is extracted from the above `startup` so that consumers
   * of this library can override it and inject their own bootstrapping
   * process. For example, HDM has multiple embed types, so we'll be
   * using an extension of the base Player class that supports these
   * types.
   *
   * @param {HTMLElement} el The DOM element to which we attach the player.
   * @param {Object} playerSettings The settings the player needs to render.
   */
  loadPlayer(el, playerSettings) {
    const player = new Player(el, playerSettings);
    player.load();
    return player;
  }
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/PlayerInjector.js